export class StringHelper {
  public static HasValue(str: string | null | undefined) {
    return !!str && !StringHelper.IsWhiteSpace(str);
  }
  private static IsWhiteSpace(str: string) {
    return str.match(/^ *$/) !== null;
  }
}
